const SITE_BASE_URL = window.siteBaseUrl;
export const shopRestBackendBaseUrl = window.shopRestBackendBaseUrl;

const getRefreshedTokenIfNeededRequest = async () => {
	try {
		const response = await fetch(`${SITE_BASE_URL}/app/my/get-token`, {
			method: 'POST',
			mode: 'cors',
			credentials: 'same-origin',
			headers: {
				'Authorization': `Bearer ${window.userToken}`,
				'Content-Type': 'application/json',
				'Accept': 'text/html'
			}
		});

		return response.text();

	} catch (error) {
		console.warn(error);
		return null;
	}
};

export const refreshKeycloakToken = async () => {
	const newUserToken = await getRefreshedTokenIfNeededRequest();

	if (!newUserToken || newUserToken === '') {
		// Redirect the user to the login page.
		window.location.href = '/app/logout';

		return;
	}

	// Update the token in the window object,
	// which is used as 'auth header' in the XHR requests to the catalog backend.
	if (newUserToken !== window.userToken) {
		window.userToken = newUserToken;
	}
};

const doFetch = async (url: string, method: string, body: any, refreshToken = true, signal?: AbortSignal): Promise<Response> => {
	return await fetch(url, {
		method,
		mode: 'cors',
		credentials: 'same-origin',
		signal,
		headers: {
			'Authorization': `Bearer ${window.userToken}`,
			'Content-Type': 'application/json'
		},
		body: body || undefined

	}).then(async (response) => {
		if (response.status === 401 && refreshToken) {
			await refreshKeycloakToken();
			return await doFetch(url, method, body, false, signal);
		}

		if (!response.ok) {
			throw new Error(`Error while executing api call, with method: ${method} and url: ${url}`);
		}

		return response;

	}).catch((error) => {
		// Let callers distinguish a user-initiated abort (e.g. stopping the live availability check) from a
		// genuine failure, so an in-flight request can be discarded instead of counted as failed.
		if (error instanceof DOMException && error.name === 'AbortError') {
			throw error;
		}

		throw new Error(`Error while executing api call, with method: ${method} and url: ${url}`);
	});
};

export const doGET = async (url: string): Promise<Response> => {
	return await doFetch(url, 'GET', null);
};

export const doPOST = async (url: string, body: unknown = null, signal?: AbortSignal) => {
	return await doFetch(url, 'POST', body, true, signal);
};

const handleFileResponse = async (response: Response, defaultFileName: string) => {
	let fileName: string | undefined = defaultFileName;
	const contentDisposition = response.headers.get('Content-Disposition');

	if (contentDisposition) {
		return await response.blob()
			.then((blob) => {
				fileName = contentDisposition.split('filename=')[1];

				return {
					blob,
					filename: fileName.replace(/['"]+/g, '')
				};
			});
	}

	throw new Error('Failed to download file.');
};

export const doDownloadGET = async (url: string, defaultFileName: string) => {
	const response = await doGET(url);
	return await handleFileResponse(response, defaultFileName);
};

export const doDownloadPOST = async (url: string, defaultFileName: string, body?: any) => {
	const response = await doPOST(url, body);
	return await handleFileResponse(response, defaultFileName);
};
